import { Box, Card } from "@mui/material";
export type SummaryBoxProps = {
  children: React.ReactNode;
  color?: colors;
};
export type colors = "success" | "secondary" | "warning" | "error" | "info";
export const SummaryBox = ({ children, color }: SummaryBoxProps) => {
  return (
    <Card
      sx={{
        display: "flex",
        borderRadius: 6,
        backgroundColor: "primary.main",
        padding: "25px 20px",
        alignItems: "center",
        paddingInline: 3,
        gap: "0.9375rem",
        position: "relative",
        ...(color && {
          borderColor: `${color}.main`,
          borderWidth: 2,
          borderStyle: "solid",
        }),
      }}
    >
      {children}
    </Card>
  );
};
